export default __webpack_public_path__ + "static/media/2.b43b3718.png";